// extracted by mini-css-extract-plugin
export default {"collapseTitle":"styles_collapseTitle__DHXCx"};